module.exports = __webpack_public_path__ + "static/media/india.f3a60ba3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/india.svg
// module id = 373
// module chunks = 1